import React from 'react';
import { formatPrice, Price, PriceAdditionalInfo, PriceInfoContainer, PriceLabel } from "../../../index.js";
export var CardPrice = function CardPrice(props) {
  var oldUnitPrice = props.oldUnitPrice,
    oldPrice = props.oldPrice,
    unitPrice = props.unitPrice,
    price = props.price,
    packetText = props.packetText,
    units = props.units,
    packagePriceFirst = props.packagePriceFirst,
    showPriceLabel = props.showPriceLabel,
    labelText = props.labelText,
    percentage = props.percentage;
  var crossedPrice = oldUnitPrice || oldPrice;
  var bigPrice = unitPrice || price || crossedPrice;
  var priceAdditionalInfo = "".concat(packetText, " ");
  var unitsStr = units;
  var additionalInfoPrice = price || oldPrice;
  if (packagePriceFirst !== false) {
    crossedPrice = oldPrice;
    bigPrice = price || crossedPrice;
    priceAdditionalInfo = "".concat(units, " ");
    unitsStr = null;
    additionalInfoPrice = unitPrice || oldUnitPrice;
  }
  if (!price) return null;
  return /*#__PURE__*/React.createElement(PriceInfoContainer, {
    "data-testid": "molecules-CardPrice-PriceInfoContainer"
  }, /*#__PURE__*/React.createElement(PriceInfoContainer.Before, null, showPriceLabel && /*#__PURE__*/React.createElement(PriceLabel, {
    text: labelText,
    percentage: percentage
  })), /*#__PURE__*/React.createElement(PriceInfoContainer.Main, null, /*#__PURE__*/React.createElement(Price, {
    oldPrice: crossedPrice,
    price: bigPrice,
    units: unitsStr
  }, unitPrice && /*#__PURE__*/React.createElement(PriceAdditionalInfo, {
    text: priceAdditionalInfo
  }, /*#__PURE__*/React.createElement("b", {
    "data-testid": "molecules-CardPrice-b"
  }, formatPrice(additionalInfoPrice))))));
};